// src/components/TopBanner.js
import React from 'react';
import '../App.css';

function TopBanner() {
    return (
        <div className="top-banner">
            <div className="container banner-content">
                <span className="banner-icon">🚗</span>
                <p className="banner-text">
                    Introducing <strong>Fleetify</strong>: No missed rentals. No missed revenue.
                </p>
                <a href="#features" className="banner-link">See How It Works</a>
                <a href="#webinar" className="banner-rsvp">RSVP to Demo</a>
            </div>
        </div>
    );
}

export default TopBanner;
